import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './RacingThemeListingGallery.module.css';

/**
 * Listing media gallery with thumbnails.
 */
const RacingThemeListingGallery = props => {
  const { items, className } = props;
  const [activeId, setActiveId] = useState(items[0]?.id);

  if (!items?.length) {
    return null;
  }

  const active = items.find(item => item.id === activeId) || items[0];

  return (
    <div className={classNames(css.root, className)}>
      <div className={css.hero}>
        <img className={css.heroImg} src={active.src} alt={active.alt || ''} />
        {active.type === 'video' ? (
          <span className={css.play} aria-hidden="true">
            ▶
          </span>
        ) : null}
      </div>
      <div className={css.thumbs} role="list">
        {items.map(item => {
          const isActive = item.id === active.id;
          return (
            <button
              key={item.id}
              type="button"
              role="listitem"
              className={classNames(css.thumb, { [css.thumbActive]: isActive })}
              aria-label={item.alt || 'Show image'}
              aria-pressed={isActive}
              onClick={() => setActiveId(item.id)}
            >
              <img src={item.thumbSrc || item.src} alt="" />
            </button>
          );
        })}
      </div>
    </div>
  );
};

RacingThemeListingGallery.defaultProps = {
  className: null,
  items: [],
};

RacingThemeListingGallery.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.string,
      src: PropTypes.string.isRequired,
      alt: PropTypes.string,
      thumbSrc: PropTypes.string,
    })
  ),
};

export default RacingThemeListingGallery;
